import React from 'react'
import ProtectedRoute from '../../internal/ProtectedRoute'
import { Authorities } from '../../models/authorities'

import Users from './Users'
import UserDetails from './UserDetails'
import AddSingleUser from './AddSingleUser'
import BatchImportUsers from './BatchImportUsers'

const UsersRoutes = () => [
  <ProtectedRoute
    key="/users"
    exact
    path="/users"
    authority={Authorities.USER_ADMINISTRATION}
    page={<Users />}
  />,
  <ProtectedRoute
    key="/user-details/id"
    exact
    path="/user-details/:id"
    authority={Authorities.USER_ADMINISTRATION}
    page={<UserDetails />}
  />,
  <ProtectedRoute
    key="/users/add-user"
    exact
    path="/users/add-user"
    authority={Authorities.USER_ADMINISTRATION}
    page={<AddSingleUser />}
  />,
  <ProtectedRoute
    key="/users/import"
    exact
    path="/users/import"
    authority={Authorities.USER_ADMINISTRATION}
    page={<BatchImportUsers />}
  />,
]

export default UsersRoutes
